import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Search, Plus, Edit, Trash2 } from "lucide-react";
import { useInvestorsController } from "./useInvestorsController";
import { InvestorAvatar } from "./components";
import { ImportButton } from "../imports/components";

export const Investors = () => {
  const controller = useInvestorsController();

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Investors</h1>
        <ImportButton context="investor" />
      </div>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Investor Management</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center gap-4 mb-4">
            <div className="relative flex-1">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search investors..."
                className="pl-8"
                value={controller.searchQuery}
                onChange={(e) => controller.setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="max-h-[80vh] overflow-auto">
            <Table>
              <TableHeader className="sticky top-0 bg-background z-10">
                <TableRow>
                  <TableHead className="w-12"></TableHead>
                  <TableHead>Key</TableHead>
                  <TableHead>Name</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {controller.isLoading ? (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-4">
                      Loading investors...
                    </TableCell>
                  </TableRow>
                ) : controller.filteredInvestors.length > 0 ? (
                  controller.filteredInvestors.map((investor) => (
                    <TableRow key={investor.investorKey}>
                      <TableCell>
                        <InvestorAvatar
                          investorKey={investor.investorKey}
                          name={investor.name}
                          size="sm"
                        />
                      </TableCell>
                      <TableCell>{investor.investorKey}</TableCell>
                      <TableCell className="font-medium">
                        {investor.name}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center py-4">
                      No investors found matching your search.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
